export default __webpack_public_path__ + "static/media/profile.7f7f09f0.jpeg";